/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RewardCategory = {
    _11184809: '11184809',
    ENTRIES: 'ENTRIES',
    IN_STORE: 'IN_STORE',
    ONLINE: 'ONLINE',
    CASH: 'CASH',
    unknown_default_open_api: '11184809'
} as const;
export type RewardCategory = typeof RewardCategory[keyof typeof RewardCategory];


export function instanceOfRewardCategory(value: any): boolean {
    for (const key in RewardCategory) {
        if (Object.prototype.hasOwnProperty.call(RewardCategory, key)) {
            if (RewardCategory[key as keyof typeof RewardCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardCategoryFromJSON(json: any): RewardCategory {
    return RewardCategoryFromJSONTyped(json, false);
}

export function RewardCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardCategory {
    return json as RewardCategory;
}

export function RewardCategoryToJSON(value?: RewardCategory | null): any {
    return value as any;
}

